import { PathPair } from "src/components/SegmentPicker/components/ListItemBreadcrumb/types"

export function toPathPairs(paths: string[]): PathPair[] {
    return paths.map((path, index) => ({ path, index }))
}
